<template>
	<div class="advert-manage-container">
		<div class="asset-list">
			<div class="header">
				<div>资产列表</div>
				<el-input placeholder="请输入内容" size="small" v-model="keyword" class="input-with-select">
					<el-button slot="append" icon="el-icon-search" @click="fetchGetAssetList"></el-button>
				</el-input>
			</div>
			<div class="body" v-loading="loading">
				<div class="list-wrapper">
					<!-- 滑动高亮块 -->
					<div
						class="active-bg"
						:style="{
							transform: `translateY(${activeId * 90 + activeId * 4}px)`,
						}"></div>
					<!-- 	:class="{ active: index == activeId }" -->
					<div class="list" v-for="(item, index) in list" :key="item.id" @click="selectTab(index, item)">
						<div class="time-number">
							<i class="el-icon-time" style="font-size: 26px; margin-bottom: 2px"></i>
							<!-- <div>{{ item.count }}条</div> -->
						</div>

						<div class="content">
							<div class="name">
								<span style="margin-right: 6px">{{ item.assetName }}</span>
								<el-tag :type="AssetStatus[item.status] || 'default'" size="small">
									{{ $menu.getLabel('AssetStatus', item.status) || '-' }}
								</el-tag>
							</div>

							<div class="no">{{ item.assetNo }} | {{ item.communityName }}</div>
							<div class="new-time">最新变动: {{ dayjs(item.recordDate).format('YYYY-MM-DD') }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="asset-time-line">
			<div class="header">
				<div>{{ activeItem.assetName }} - 资产动态</div>
				<el-button
					type="primary"
					icon="el-icon-plus"
					size="small"
					@click="
						() => {
							dialogVisible = true;
						}
					">
					新增变动
				</el-button>
			</div>
			<div class="body">
				<el-empty v-if="!activeItem" description="暂无资产动态可查看" />
				<div v-else class="">
					<div class="info-list">
						<div>
							<div>资产编号</div>
							<div class="val">{{ activeItem.assetNo }}</div>
						</div>
						<div>
							<div>资产分类</div>
							<div class="val">{{ $menu.getLabel('AssetCategory', activeItem.assetCategory) }}</div>
						</div>
						<div>
							<div>建筑面积</div>
							<div class="val">{{ activeItem.buildingArea }} ㎡</div>
						</div>
						<div>
							<div>资产原值</div>
							<div class="val">{{ activeItem.originalValue }} 万元</div>
						</div>
					</div>
					<el-empty v-if="!detailList.length" description="暂无资产动态" />
					<div class="times-line" v-else>
						<div class="timeline">
							<div class="timeline-item" v-for="(item, index) in detailList" :key="index" :style="{ '--i': index }">
								<!-- 左边时间 -->
								<div class="time">
									<div>{{ item.changeDate }}</div>
									<div class="person">{{ item.updater }}</div>
								</div>

								<!-- 中间轴 -->
								<div class="axis">
									<div class="dot">
										<i class="el-icon-edit"></i>
									</div>
									<div class="line" v-if="index !== list.length - 1"></div>
								</div>

								<!-- 右边内容 -->
								<div class="content">
									<el-card class="card">
										<div class="card-header">
											<el-tag :type="AssetChangeType[item.changeType] || 'default'" class="tag" size="mini">
												{{ $menu.getLabel('AssetChangeType', item.changeType) }}
											</el-tag>

											<el-tag size="mini" :type="item.statusTagType" v-if="item.statusTag">
												{{ item.statusTag }}
											</el-tag>
										</div>

										<div class="code">{{ item.assetNo }}</div>
										<div class="title">{{ item.changeSubType }}</div>
										<div class="change">
											<span class="before">变更前: {{ item.changeBefore }}</span>
											<i class="el-icon-right" style="color: #409eff; margin: 0 6px"></i>
											<span class="after">变更后: {{ item.changeAfter }}</span>
										</div>
										<div class="reason">原因: {{ item.changeDescription }}</div>
										<div class="detail" @click="showDetail(item)">查看详情</div>
									</el-card>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<AssetDynamicDialog :dialogVisible.sync="dialogVisible" :data="activeItem" @updateSuccess="updateSuccess" />
		<AssetDynamicDrawer :dialogVisible.sync="drawerVisible" :data="planeItem" />
	</div>
</template>

<script>
	import dayjs from 'dayjs';
	import AssetDynamicDialog from '@/components/asset/assetDynamicDialog.vue';
	import AssetDynamicDrawer from '@/components/asset/assetDynamicDrawer.vue';
	import { getCommunityId } from '@/utils/vc.js';
	import { AssetStatus, AssetChangeType } from '@/utils/meunType.js';
	import { getAssetList } from '@/api/asset/assetLedgerApi.js';
	import { getAssetChangeListByAssetId } from '@/api/asset/assetDynamicApi.js';
	export default {
		name: 'AssetDynamic',
		components: { AssetDynamicDialog, AssetDynamicDrawer },
		data() {
			return {
				AssetChangeType,
				AssetStatus,
				loading: false,
				keyword: '',
				list: [],
				activeId: 0,
				activeItem: {},
				detailList: [
					// {
					// 	time: '2026/03/31',
					// 	typeTag: '资产变更',
					// 	person: '王明刚',
					// 	typeTagType: 'warning',
					// 	statusTag: '已完成',
					// 	statusTagType: 'success',
					// 	code: 'BD-GH-2026-001',
					// 	title: '规划类型变更：非经他用 → 租赁经营',
					// 	before: '非经他用',
					// 	after: '租赁经营',
					// 	reason: '经营策略调整',
					// },
					// {
					// 	time: '2026/01/03',
					// 	typeTag: '资产变更',
					// 	person: '王明刚',
					// 	typeTagType: 'warning',
					// 	statusTag: '处理中',
					// 	statusTagType: 'info',
					// 	code: 'BD-GH-2026-002',
					// 	title: '规划类型变更：租赁经营 → 销售去化',
					// 	before: '租赁经营',
					// 	after: '销售去化',
					// 	reason: '资产处置计划',
					// },
				],
				dialogVisible: false,
				drawerVisible: false,
				planeItem: {},
			};
		},
		created() {
			this.fetchGetAssetList();
		},
		methods: {
			dayjs,
			async fetchGetAssetList() {
				try {
					this.loading = true;
					const res = await getAssetList({ communityId: getCommunityId(), keyword: this.keyword });
					// console.log(res, 'getAssetList');
					this.list = res;
					if (res && res.length) {
						this.activeItem = res[0];
						await this.fetctGetAssetChangeListByAssetId(res[0].id);
					}
				} catch (error) {
					this.$message.error('查询资产列表失败');
				} finally {
					this.loading = false;
				}
			},
			async fetctGetAssetChangeListByAssetId(assetId) {
				try {
					const res = await getAssetChangeListByAssetId(assetId);
					this.detailList = res;
					// console.log(res, 'getAssetChangeListByAssetId');
				} catch (error) {
					this.$message.error('查询资产记录失败');
				}
			},
			showDetail(item) {
				this.planeItem = item;
				this.drawerVisible = true;
			},
			selectTab(index, item) {
				this.activeId = index;
				this.activeItem = item;
				this.fetctGetAssetChangeListByAssetId(item.id);
			},
			updateSuccess() {
				this.fetctGetAssetChangeListByAssetId(this.activeItem.id);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.advert-manage-container {
		padding: 20px;
		text-align: left;
		display: flex;
		gap: 16px;
		.asset-list {
			border-radius: 10px;
			border: 1px solid #dcdfe6;
			width: 35%;
			background-color: #fff;
		}
		.asset-time-line {
			flex: 1;
			border-radius: 10px;
			border: 1px solid #dcdfe6;
			background-color: #fff;
		}

		.header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 12px 18px;
			font-weight: 600;
			border-bottom: 1px solid #dcdfe6;
			.input-with-select {
				width: 200px;
			}
		}

		.body {
			padding: 12px 18px;
			overflow-y: auto;
			height: 75vh;
			&::-webkit-scrollbar {
				width: 6px;
			}

			/* 滚动条轨道 */
			&::-webkit-scrollbar-track {
				background: #f5f5f5;
				border-radius: 3px;
			}

			/* 滑块 */
			&::-webkit-scrollbar-thumb {
				background: #bbbbbb;
				border-radius: 3px;
				transition: all 0.3s;
			}

			/* hover 时 */
			&::-webkit-scrollbar-thumb:hover {
				background: #a8a8a8;
			}
		}

		.list {
			position: relative;
			display: flex;
			align-items: center;
			padding: 14px 0;
			padding-left: 12px;
			border-radius: 0 10px 10px 0;
			border-bottom: 1px solid #e5e9f2;
			cursor: pointer;
			z-index: 1;
			height: 90px;
			margin-top: 4px;
			box-sizing: border-box;

			.time-number {
				color: rgb(24, 144, 255);
				font-size: 14px;
				text-align: center;
				padding: 6px 3px;
				background-color: rgb(24, 144, 255, 0.2);
				width: 55px;
				border-radius: 5px;
			}
			.content {
				flex: 1;
				margin-left: 14px;
				font-size: 14px;

				.name {
					font-weight: bold;
				}
				.no {
					margin: 3px 0;
					color: #666;
				}
				.new-time {
					color: #999;
				}
			}
		}

		.list-wrapper {
			position: relative;
		}

		.active-bg {
			position: absolute;
			left: 0;
			right: 0;
			height: 90px;
			background: rgb(24, 144, 255, 0.15);
			border-radius: 8px;
			z-index: 0;
			border: none;
			transition: all 0.3s ease;
		}

		.active-bg::before {
			content: '';
			position: absolute;
			left: 0;
			top: 0;
			bottom: 0;
			width: 4px;
			background-color: rgb(24, 144, 255);
			border-radius: 4px 0 0 4px;
		}

		.info-list {
			width: 100%;
			display: flex;
			justify-content: space-around;
			border-radius: 10px;
			padding: 12px 16px;
			box-sizing: border-box;
			background-color: #f5f5f5;
			font-size: 14px;
			color: #999;
			.val {
				font-size: 16px;
				font-weight: bold;
				color: #333;
				margin-top: 3px;
			}
		}

		.times-line {
			margin-top: 24px;
			display: flex;
			justify-content: flex-end;

			.timeline {
				width: 70%;
			}

			.timeline-item {
				display: grid;
				grid-template-columns: 120px 40px 1fr;
				position: relative;
				margin-bottom: 24px;
				opacity: 0;
				transform: translateY(20px);
				animation: fadeInUp 0.4s ease forwards;
				animation-delay: calc(var(--i) * 0.05s);

				.time {
					padding-top: 5px;
					text-align: right;
					padding-right: 10px;
					color: #333;
					font-size: 16px;
					font-weight: bold;
				}

				.person {
					font-size: 14px;
					color: #666;
					font-weight: normal;
					margin-top: 4px;
				}

				.axis {
					position: relative;
					display: flex;
					justify-content: center;
				}

				.dot {
					width: 24px;
					height: 24px;
					background-color: #fff;
					color: #409eff;
					border-radius: 50%;
					display: flex;
					align-items: center;
					justify-content: center;
					z-index: 2;
					transition: all 0.3s;
				}

				.line {
					position: absolute;
					top: 24px;
					width: 2px;
					height: calc(100% + 24px);
					background: #ebeef5;
				}

				.content {
					padding-left: 10px;

					.card {
						transition: all 0.3s;
						border-radius: 10px;
						font-size: 12px;
						.card-header {
							display: flex;
							margin-bottom: 10px;
							gap: 8px;
						}

						.code {
							color: #333;
							font-weight: bold;
							font-size: 14px;
						}
						.code,
						.title,
						.change {
							margin-bottom: 5px;
						}

						.change {
							display: inline-block;
							border-radius: 3px;
							background-color: #f2f1f1;
							padding: 8px 7px;
							box-sizing: border-box;
						}
						.before {
							color: #666;
						}
						.after {
							color: #67c23a;
						}

						.reason {
							color: #5d5d5d;
						}

						.detail {
							text-align: center;
							padding-top: 12px;
							border-top: 1px solid #e5e9f2;
							margin-top: 12px;
							font-size: 14px;
							color: #409eff;
							cursor: pointer;
						}
						.detail:hover {
							opacity: 0.8;
						}
					}
				}
			}

			.timeline-item:last-child .line {
				display: none;
			}
		}
	}

	@keyframes fadeInUp {
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
</style>
